import { envConfig } from "@env/env-config"

export class RecaptchaHelper {

    public static script: HTMLScriptElement
    public static widget: HTMLDivElement

    public static loadGrecaptchaScriptLabel() {
        if (!document.getElementById('grecaptcha_script')) {
            window.grecaptchaOnload = RecaptchaHelper.grecaptchaOnload

            const site_key = envConfig.googleRecaptchaSecretKey()
            /**
             * @description: 代理使用google recaptcha
             */
            // const url = 'https://www.google.com/recaptcha/api.js'
            /** 
             * @description: 全球使用google recaptcha
             * docs: https://developers.google.com/recaptcha/docs/faq?hl=zh-cn#can-i-use-recaptcha-with-third-party-solutions
             */
            const url = 'https://www.recaptcha.net/recaptcha/api.js'
            const queryString = `?onload=grecaptchaOnload&render=${site_key}&hl=en`
            const script = document.createElement('script')
            script.type = 'text/javascript'
            script.src = url + queryString
            script.async = true
            script.defer = true
            script.id = "grecaptcha_script"

            RecaptchaHelper.script = document.body.appendChild(script)
        }
    }

    public static grecaptchaOnload() {
        /* 
         * Squarespace form blocks do not support reCAPTCHA V3.0 Site or Secret Keys at the moment.
         * Must stick with V2.0 Keys for the time being. 
         */
        // const widget = document.createElement('div')
        // widget.id = 'g-recaptcha'
        // RecaptchaHelper.widget = document.body.appendChild(widget)

        // window.grecaptcha.render(widget.id, {
        //     sitekey: Environment.RECAPTCHA_KEY.SITE,
        //     size: 'invisible'
        // })

        window.grecaptcha.ready(() => {
            // ready set
            window.isGrecaptcha = true;
        })
    }
}